/* Brossange C12 : suivi des interactions (docs/PLAN_MARQUAGE.md). Rien n'est publié sans l'accord « Analyse » :
   file publiée après accord, jetée au refus. Jamais de texte saisi ni de paramètre d'adresse. */
(() => {
  'use strict';
  const W = window;
  const D = document;
  const sh = () => W.Shopify || {};
  const page = () => (D.body && D.body.dataset.pageType) || 'autre';
  // Texte court, sans e-mail ni longue suite de chiffres
  const court = (s, n) => String(s == null ? '' : s).replace(/\S+@\S+/g, '').replace(/\d{6,}/g, '').replace(/\s+/g, ' ').trim().slice(0, n || 60);

  // Debug : ?debug_track=1, gardé pour la session ; panneau à part
  const lignes = [];
  let debug = false;
  try {
    const p = new URLSearchParams(location.search).get('debug_track');
    const s = W.sessionStorage;
    if (p) p === '1' ? s.setItem('bt-debug', '1') : s.removeItem('bt-debug');
    debug = s.getItem('bt-debug') === '1';
  } catch (e) { /* stockage bloqué */ }
  const src = D.currentScript && D.currentScript.dataset.debug;
  if (debug && src) {
    W.BrossangeTrackJournal = lignes;
    D.head.appendChild(Object.assign(D.createElement('script'), { src }));
  }
  const journal = (n, d, statut) => {
    if (!debug) return;
    lignes.push({ t: new Date().toISOString().slice(11, 19), n, statut, d });
    if (W.BrossangeTrackDebug) W.BrossangeTrackDebug();
  };

  // Consentement ; Clarity : palier, couleur, landing, expérience
  const file = [];
  const accord = () => { try { return !!sh().customerPrivacy.analyticsProcessingAllowed(); } catch (e) { return false; } };
  const refus = () => { try { return sh().customerPrivacy.currentVisitorConsent().analytics === 'no'; } catch (e) { return false; } };
  const CL = { nb_brosses: 'palier', finition: 'couleur', landing: 'landing' };
  const envoyer = (n, d) => {
    try { sh().analytics.publish(n, d); } catch (e) { /* pixels absents */ }
    const c = W.clarity;
    if (typeof c === 'function') {
      Object.keys(CL).forEach((k) => { if (d[k] != null) c('set', CL[k], String(d[k])); });
      if (n === 'brossange_experiment_exposure') c('set', 'experience', `${d.id}:${d.variante}`);
    }
    journal(n, d, 'publié');
  };
  const vider = () => { while (file.length) envoyer(...file.shift()); };
  const pub = (n, data) => {
    const d = Object.assign({ page: page() }, data);
    if (accord()) { vider(); envoyer(n, d); } else if (refus()) journal(n, d, 'jeté');
    else { if (file.push([n, d]) > 80) file.shift(); journal(n, d, 'en attente'); }
  };
  D.addEventListener('visitorConsentCollected', (e) => {
    const a = e.detail && e.detail.analyticsAllowed;
    if (a) vider(); else if (a === false) file.length = 0;
  });
  try {
    if (!sh().customerPrivacy) sh().loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (er) => { if (!er && accord()) vider(); });
  } catch (e) { /* API absente */ }
  // File des autres scripts : brossangeQ.push([nom, données])
  const avant = W.brossangeQ;
  W.brossangeQ = { push: (x) => pub(x[0], x[1]) };
  if (Array.isArray(avant)) avant.forEach((x) => pub(x[0], x[1]));

  // Clics ; lien non marqué : <section>:lien-texte
  const lieu = (el) => { const s = el.closest('[data-track-section]'); return s ? s.dataset.trackSection : null; };
  const libelle = (el) => {
    if (el.dataset.trackLabel) return court(el.dataset.trackLabel);
    const l = el.labels && el.labels[0] ? el.labels[0].textContent : '';
    // Saisie ou liste : nom du champ, jamais la valeur
    if (/^(text|email|tel|search|password|number|url|textarea|select-one)$/.test(el.type)) return court(l || el.name);
    return court(el.getAttribute('aria-label') || el.textContent || l || el.value);
  };
  const cliquer = (el, id) => {
    const a = el.closest('a[href]');
    let u = null;
    try { u = a && new URL(a.getAttribute('href'), location.href); } catch (e) { /* illisible */ }
    const proto = u && /^(mailto|tel):$/.test(u.protocol);
    const ici = u && u.origin === location.origin;
    pub('brossange_click', { id, pos: el.dataset.trackPos || null, section: lieu(el), href: !u ? null : (proto ? u.protocol.slice(0, -1) : (ici ? '' : u.hostname) + u.pathname), label: libelle(el) });
    if (el.closest('[data-cookies]')) pub('brossange_cookies_open', { id });
    if (!u) return;
    if (a.hasAttribute('download') || /\.pdf$/i.test(u.pathname)) pub('brossange_telechargement', { id, fichier: court(u.pathname.split('/').pop(), 80) });
    else if (proto || (!ici && /^http/.test(u.protocol))) pub('brossange_lien_sortant', proto ? { id, type: u.protocol === 'tel:' ? 'telephone' : 'email' } : { id, type: 'site', domaine: u.hostname });
  };
  D.addEventListener('click', (e) => {
    const el = e.target.closest && e.target.closest('[data-track], a[href]');
    if (el && el.tagName !== 'SELECT') cliquer(el, el.dataset.track || `${lieu(el) || page()}:lien-texte`);
  }, true);
  D.addEventListener('change', (e) => { const el = e.target; if (el.tagName === 'SELECT' && el.dataset.track) cliquer(el, el.dataset.track); }, true);

  // Sections vues : moitié visible ou milieu de l'écran atteint
  if (W.IntersectionObserver) {
    const vus = new WeakSet();
    const vue = (t) => { if (!vus.has(t)) { vus.add(t); pub('brossange_section_view', { id: t.dataset.trackSection }); } };
    const io1 = new IntersectionObserver((es) => es.forEach((x) => { if (x.intersectionRatio >= 0.5) vue(x.target); }), { threshold: 0.5 });
    const io2 = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) vue(x.target); }), { rootMargin: '-50% 0px -50% 0px' });
    D.querySelectorAll('[data-track-section]').forEach((s) => { io1.observe(s); io2.observe(s); });
  }

  // Défilement 25, 50, 75, 100 %
  let palier = 0;
  let image = 0;
  W.addEventListener('scroll', () => {
    if (!image) {
      image = requestAnimationFrame(() => {
        image = 0;
        const h = D.documentElement.scrollHeight - innerHeight;
        while (palier < 4 && h > 0 && (scrollY / h) * 100 >= 25 * (palier + 1) - 1) pub('brossange_scroll', { pct: 25 * ++palier });
      });
    }
  }, { passive: true });

  // Temps actif (onglet visible, action récente), envoyé à la sortie
  let actif = 0;
  let derniere = Date.now();
  ['pointerdown', 'keydown', 'scroll', 'mousemove'].forEach((t) => W.addEventListener(t, () => { derniere = Date.now(); }, { passive: true, capture: true }));
  setInterval(() => { if (D.visibilityState === 'visible' && Date.now() - derniere < 3e4) actif += 1; }, 1e3);
  const bilan = () => { if (actif) pub('brossange_engagement', { secondes: actif }); actif = 0; };
  D.addEventListener('visibilitychange', () => { if (D.hidden) bilan(); });
  W.addEventListener('pagehide', bilan);

  // Formulaires : envoi, champ invalide (sans valeur), succès, erreurs
  D.addEventListener('submit', (e) => { const n = e.target.dataset && e.target.dataset.trackForm; if (n) pub('brossange_form_submit', { form: n }); }, true);
  let invalide = 0;
  D.addEventListener('invalid', (e) => {
    const el = e.target;
    const n = el.form && el.form.dataset.trackForm;
    if (!n || Date.now() - invalide < 500) return;
    invalide = Date.now();
    const v = el.validity;
    pub('brossange_form_error', { form: n, champ: court(String(el.name).replace(/^\w+\[|\]$/g, '').normalize('NFD').replace(/[^\w-]/g, '').toLowerCase(), 40), erreur: v.valueMissing ? 'vide' : (v.typeMismatch || v.patternMismatch ? 'format' : 'autre'), source: 'navigateur' });
  }, true);
  D.querySelectorAll('[data-track-succes]').forEach((m) => pub('brossange_form_success', { form: m.dataset.trackSucces }));
  D.querySelectorAll('[data-track-erreurs]').forEach((m) => {
    const [form, champs] = m.dataset.trackErreurs.split(':');
    pub('brossange_form_error', { form, champ: court(champs), erreur: 'serveur', source: 'shopify' });
  });

  // 404 (chemin) ; recherche (nombre de résultats, jamais les mots)
  if (page() === '404') pub('brossange_404', { chemin: court(location.pathname, 100) });
  const r = D.querySelector('[data-track-recherche]');
  if (r) pub('brossange_recherche', { nb_resultats: Number(r.dataset.trackRecherche) || 0 });

  // Vidéo : début, moitié, fin
  const media = (e) => {
    const v = e.target;
    if (v.tagName !== 'VIDEO') return;
    const vu = v.btVu || (v.btVu = {});
    const etape = e.type === 'play' ? 'debut' : (e.type === 'ended' ? 'fin' : (v.currentTime / v.duration >= 0.5 ? 'milieu' : ''));
    if (etape && !vu[etape]) { vu[etape] = 1; pub('brossange_video', { id: lieu(v) || page(), etape }); }
  };
  ['play', 'timeupdate', 'ended'].forEach((t) => D.addEventListener(t, media, true));

  // Copie dans data-track-code, jamais le texte copié
  D.addEventListener('copy', () => {
    try {
      const n = getSelection().anchorNode;
      const z = (n.nodeType === 1 ? n : n.parentElement).closest('[data-track-code]');
      if (z) pub('brossange_code_copie', { id: z.dataset.trackCode });
    } catch (e) { /* aucune sélection */ }
  });

  // Erreurs JS : message tronqué, fichier, ligne ; cinq au plus
  let erreurs = 0;
  const erreur = (m, f, l) => { if (erreurs++ < 5) pub('brossange_js_error', { message: court(m, 100), fichier: court(String(f || '').split('?')[0].split('/').pop()), ligne: l || 0 }); };
  W.addEventListener('error', (e) => { if (e.message) erreur(e.message, e.filename, e.lineno); });
  W.addEventListener('unhandledrejection', (e) => { const x = e.reason; erreur(x && x.message ? x.message : x, '', 0); });
})();
